export default __webpack_public_path__ + "static/media/ISC-PropEx-BG-Image.f895679a.jpg";